const announcementValues = {
	default: {
		link: 'https://www.pluralsight.com/courses/design-patterns-overview',
		text:
			'🤖▶️ Check out the Design Patterns Overview course by Steve @ardalis Smith!',
	},
	practices: {
	 	link: 'https://nimblepros.com/',
	 	text: '💻 Need training or mentoring on software engineering practices? Contact NimblePros',
	},
	// principles: {
	// 	link: 'https://deviq.com/',
	// 	text: 'principles Announcement',
	// },
	// values: {
	// 	link: 'https://deviq.com/',
	// 	text: 'values Announcement',
	// },
	antipatterns: {
	 	link: 'https://www.youtube.com/playlist?list=PL9aiMUEQ7sc944-LmunwduqFL1tHSE2fE',
	 	text: '👻 Make your codebase less haunted with better design patterns!',
	},
	'domain-driven-design': {
	 	link: 'https://www.pluralsight.com/courses/fundamentals-domain-driven-design',
	 	text: '🐶 Learn about the fundamentals of Domain-Driven Design with Julie Lerman and Steve @ardalis Smith!',
	},
	'design-patterns': {
	 	link: 'https://www.youtube.com/playlist?list=PL9aiMUEQ7sc944-LmunwduqFL1tHSE2fE',
	 	text: '▶️ Want to learn more about design patterns? Learn more from NimblePros on YouTube!',
	},
	'architecture': {
			link: 'https://dometrain.com/author/steve-ardalis-smith/',
			text: '⚙️ From ASP.NET Core to modular monoliths, learn more from Steve @ardalis Smith!',
	}
};
export default announcementValues;
